import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore, doc, updateDoc, serverTimestamp } from 'firebase/firestore';
import { ErrorStatus } from '@/types';

// Firebase configuration - uses same project as main app
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);

/**
 * Update the status of an error
 */
export async function updateErrorStatus(
  errorId: string,
  status: ErrorStatus,
  userEmail?: string
): Promise<void> {
  const errorRef = doc(db, 'errors', errorId);

  const updateData: Record<string, unknown> = {
    status,
    resolved: status === 'resolved',
  };

  if (status === 'investigating') {
    updateData.investigatingAt = serverTimestamp();
    updateData.investigatingBy = userEmail || 'unknown';
  } else if (status === 'resolved') {
    updateData.resolvedAt = serverTimestamp();
    updateData.resolvedBy = userEmail || 'unknown';
  }

  await updateDoc(errorRef, updateData);
}

export default app;
